/* global document */
import classNames from 'classnames';
import { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import APIError from 'common/components/layout/components/APIError';
import { isRavenswood } from 'common/helpers/featureFlags';
import { getCartTitle } from 'common/helpers/miscHelper';
import { getCart, showSideCart, hideSideCart } from 'redux/cart/actions';

import CartCarrot from './components/CartCarrot';
import Loading from './components/Loading';
import Proceed from './components/Proceed';
// eslint-disable-next-line import/no-cycle
import SideCartDisplay from './components/SideCartDisplay';
import SideCartMessage from './components/SideCartMessage';
import UserTools from './components/UserTools';

class SideCart extends Component {
  componentDidMount() {
    const { props } = this;
    props.getCart();
  }

  // UNSAFE_componentWillUpdate(nextProps) {
  //   const nextCart = nextProps.cart.data;
  //   const currentCart = this.props.cart.data;
  //   if (currentCart && nextCart && currentCart.total !== nextCart.total) {
  //     this.setState({ isVisible: true });
  //   }
  // }

  handleShowCart = () => {
    const { props } = this;
    document.body.classList.add('c7-cart-open');
    props.showSideCart();
  };

  handleHideCart = (e) => {
    e.preventDefault();
    const { props } = this;
    document.body.classList.remove('c7-cart-open');
    props.hideSideCart();
  };

  render() {
    const { settings, cart } = this.props;
    const { isSideCartVisible } = cart;
    const title = getCartTitle(settings);
    if (isSideCartVisible) {
      document.body.classList.add('c7-cart-open');
    }
    if (!settings.data || !cart.data) {
      return null;
    }
    return ReactDOM.createPortal(
      <>
        <UserTools
          cart={cart.data}
          onShowCart={this.handleShowCart}
          settings={settings}
        />
        <section
          id="c7-side-cart"
          className={classNames('c7-cart', isSideCartVisible && 'c7-visible')}
          role="dialog"
          aria-labelledby="c7-cart-title"
        >
          <a
            href="#"
            onClick={this.handleHideCart}
            className="c7-cart__close"
            aria-label="Close cart"
          >
            X
          </a>
          <APIError position="sideCart" />
          {isRavenswood() && (
            <div className="c7-cart__title" id="c7-cart-title">
              Shopping {title}
            </div>
          )}
          {!isRavenswood() && <h1 id="c7-cart-title">Shopping {title}</h1>}
          <CartCarrot location="Side Cart Top" cart={cart.data} />
          <div className="c7-cart__buttons--top">
            <Proceed cart={cart.data} showViewCart settings={settings} />
          </div>
          <Loading cart={cart} settings={settings} />
          <SideCartDisplay cart={cart.data} settings={settings} />
          <SideCartMessage settings={settings} />
          <CartCarrot location="Side Cart Bottom" cart={cart.data} />
          <Proceed cart={cart.data} showViewCart settings={settings} />
        </section>
      </>,
      document.getElementById('c7-cart')
    );
  }
}

const mapStateToProps = (state) => ({
  cart: state.cart,
  settings: state.setting
});

export default connect(mapStateToProps, {
  getCart,
  showSideCart,
  hideSideCart
})(SideCart);
